import React from "react"
import { Link } from "gatsby"

export const FooterSocket = () => {
  return (
    <div className="box" style={{ backgroundColor: "#013243" }}>
      <div className="container">
        <div className="columns is-vcentered px-3">
          <div className="column is-narrow">
            <Link to={"/"} style={{ color: "white" }}>
              B_I MEDIEN GmbH
            </Link>
          </div>
          <div className="column is-narrow has-text-centered">
            <div
              className="mx-3"
              style={{
                borderLeft: "1px solid white",
                height: 24,
                opacity: 0.2,
              }}
            ></div>
          </div>
          <div className="column is-narrow">
            <Link to={"/impressum"} className="has-text-white link is-semi-shy">
              Impressum
            </Link>
          </div>

          {/* <div className="column is-narrow">
            <Link
              to={"/ueber-uns/kontakt"}
              className="has-text-white link is-semi-shy"
            >
              Kontakt
            </Link>
          </div> */}

          <div className="column is-narrow ">
            <Link
              to={"/datenschutzerklaerung"}
              className="has-text-white link is-semi-shy"
            >
              Datenschutz
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}
